import React, { Component } from 'react';
import { Link, NavLink } from "react-router-dom";

import logo from '../../../assets/images/logo.png';

class Navbar extends Component {
  render() {
    return (
      <div className="home-header">
        <Link to="/home">
          <div className="header-left">
            <img alt="logo" src={logo} />
          </div>
        </Link>
        <div className="header-right right-menu">
          <div className="main-menu">
            <NavLink activeClassName='is-active' to="/Invoicing">Invoicing</NavLink>
            <NavLink activeClassName='is-active' to="/Shipping">Shipping</NavLink>
            <NavLink activeClassName='is-active' to="/Production">Production</NavLink>
            <NavLink activeClassName='is-active' to="/ArtworkProofing">Artwork Proofing </NavLink>
            <NavLink activeClassName='is-active' to="/OrderEntry">Order Entry</NavLink>
          </div>
        </div>
      </div>
    )
  }
}

export default Navbar
